<template>
    <span class="release-btn" @click="show">
        探索可替代产品
        <img src="../../assets/images/fbxq.png" alt="">
    </span>
</template>

<script>
export default {
    props: {
        instance: {
            required: true,
            default: {}
        },
        saveOptions: {
            default: {}
        }
    },
    methods: {
        show() { 
            this.instance && this.instance.show(this.saveOptions, {}, function () { }, true)
        }
    }
}
</script>

<style lang="less" scoped>
.release-btn {
  width: 14rem;
  height: 4rem;
  line-height: 4rem;
  font-size: 1.25rem;
  text-align: center;
  color: #fff;
  background: #ff8d6b;
  position: fixed;
  left: 50%;
  bottom: 2%;
  transform: translate(-50%, -50%);
  border-radius: 0.5rem;
}
.release-btn img {
  width: 2rem;
  vertical-align: middle;
  margin-left: 0.4rem;
  border-radius: 8px;
}
</style>



// WEBPACK FOOTER //
// src/components/common/demand-btn.vue